export const WEEK = 604800000;
export const YEAR = 3154e7;
export const NEWSLETTER_NAME = 'nameNewsLetter';
